<template>
    <div class="sw-modal">
        <div v-click-outside="close" v-if="establishment" class="sw-modal-content">
            <div class="row sw-modal-heading">
                <div class="col"><h4><i class="fas fa-info-circle"></i>{{establishment.name}}</h4></div>
            </div>
            <div class="sw-modal-body">
                <div class="row">
                    <div class="col-12 details-section-header">
                        <div class="details-section-header__title">Contact info</div>
                        <div class="details-section-header__line"></div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Contact:</div>
                            <div class="col-8 details--value">{{establishment.contactInfo.contact}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Email:</div>
                            <div class="col-8 details--value">{{establishment.contactInfo.email}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Telephone:</div>
                            <div class="col-8 details--value">{{establishment.contactInfo.telephone}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Mobile:</div>
                            <div class="col-8 details--value">{{establishment.contactInfo.mobile}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Website:</div>
                            <div class="col-8 details--value">{{establishment.contactInfo.website}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Address:</div>
                            <div class="col-8 details--value">{{establishment.contactInfo.address}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Directions:</div>
                            <div class="col-8 details--value">{{establishment.contactInfo.directions}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">GPS:</div>
                            <div class="col-8 details--value">{{getGPSCoords}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 details-section-header">
                        <div class="details-section-header__title">Check-in & out</div>
                        <div class="details-section-header__line"></div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Check-in:</div><div class="col-8 detail__value">{{establishment.rules.checkInTime}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Check-out:</div><div class="col-8 detail__value">{{establishment.rules.checkOutTime}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 details-section-header">
                        <div class="details-section-header__title">Child policy</div>
                        <div class="details-section-header__line"></div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Category 1:</div><div class="col-8 detail__value">{{establishment.rules.childAgeLowerLimit}} yrs - {{establishment.rules.childCategory1AgeLimit}} yrs</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-4">Category 2:</div><div class="col-8 detail__value">{{establishment.rules.childCategory1AgeLimit}} yrs - {{establishment.rules.childCategory2AgeLimit}} yrs</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 details-section-header">
                        <div class="details-section-header__title">Cancellation policy</div>
                        <div class="details-section-header__line"></div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-12">{{establishment.rules.cancellationPolicy}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 details-section-header">
                        <div class="details-section-header__title capitalize">{{getUnitTypeForDisplay}}</div>
                        <div class="details-section-header__line"></div>
                    </div>
                    <div class="col-12 room-types">
                        <ul>
                            <li v-for="(roomType, index) of establishment.roomTypes" v-bind:key="index">
                                <div class="row">
                                    <div class="col-12 room-type__name">
                                        <i v-bind:class="getUnitIconForDisplay" aria-hidden="true"></i> {{roomType.name}} (x {{roomType.roomCount}})
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 detail__label"><i class="fas fa-users"></i> Max occupancy</div>
                                    <div class="col-6 detail__value">{{roomType.maxOccupancy}} ({{roomType.maxAdults}} adults)</div>
                                </div>
                                <div class="row">
                                    <div class="col-6 detail__label"><i class="fas fa-bed"></i> Beds</div>
                                    <div class="col-6 detail__value">
                                        {{roomType.numberOfBeds}}
                                        <template v-if="roomType.numberOfBedrooms > 0">
                                            (in {{roomType.numberOfBedrooms}} room<template v-if="roomType.numberOfBedrooms > 1">s</template>)
                                        </template>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 detail__label"><i class="fas fa-expand-arrows-alt"></i> Size</div>
                                    <div class="col-6 detail__value">{{roomType.sizeInSquareMeters}} m<sup>2</sup></div>
                                </div>
                                <div class="row">
                                    <div class="col-6 detail__label"><i class="fas fa-broom"></i> Cleaning fee</div>
                                    <div class="col-6 detail__value">{{establishment.rules.currencyCode}} {{roomType.cleaningFee}}</div>
                                </div>
                                <div class="row">
                                    <div class="col-6 detail__label"><i class="fas fa-coins"></i> Security deposit</div>
                                    <div class="col-6 detail__value">{{establishment.rules.currencyCode}} {{roomType.breakageDeposit}}</div>
                                </div>
                                <template v-if="roomType.childPolicy">
                                    <div class="row">
                                        <div class="col-6 detail__label"><i class="fas fa-child"></i> {{establishment.rules.childAgeLowerLimit}} yrs - {{establishment.rules.childCategory1AgeLimit}} yrs?</div>
                                        <div class="col-6 detail__value">
                                            <span v-if="roomType.childPolicy.allowChildCategory1">Yes</span>
                                            <span v-else>No</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6 detail__label"><i class="fas fa-child"></i> {{establishment.rules.childCategory1AgeLimit}} yrs - {{establishment.rules.childCategory2AgeLimit}} yrs?</div>
                                        <div class="col-6 detail__value">
                                            <span v-if="roomType.childPolicy.allowChildCategory2">Yes</span>
                                            <span v-else>No</span>
                                        </div>
                                    </div>
                                </template>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row" v-if="establishment.provider">
                    <div class="col-12 details-section-header">
                        <div class="details-section-header__title">{{establishment.provider.name}}</div>
                        <div class="details-section-header__line"></div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-6">Last sync:</div>
                            <div class="col-6 detail__value">{{getLastSyncDate}}</div>
                        </div>
                    </div>
                    <div class="col-12 details-section-detail">
                        <div class="row">
                            <div class="col-6">
                                Synchronize now
                            </div>
                            <div class="col-6 text-center">
                                <button v-on:click.stop="synchronize" class="btn btn-secondary">
                                    <i class="fas fa-sync"></i>
                                    Sync
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-show="syncing && !success" class="col-12">
                        <Spinner/>
                    </div>
                </div>
                <div v-if="message" class="row sync-message">
                    <div v-if="success" class="col-12 alert alert-success" role="alert">
                        {{message}}
                    </div>
                    <div v-if="!success" class="col-12 alert alert-danger" role="alert">
                        {{message}}
                    </div>
                </div>
            </div>
            <div class="sw-modal-actions">
                <div class="row">
                    <div class="col text-center">
                        <button class="btn btn-primary" v-on:click="close">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mutations, getters } from '../../store.js'
    import Spinner from '../Spinner.vue'
    import * as dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    dayjs.extend(utc);
    // import Tooltip from '../Tooltip'

    export default {
        name: 'EstablishmentDetails',
        components: {
            Spinner//, Tooltip
        },
        props: {
            establishment: Object
        },
        data: function() {
            return {
                syncing: false,
                message: "",
                success: false
            }
        },
        computed: {
            getGPSCoords: function() {
                return (Math.round(this.establishment.contactInfo.latitude * 1000000) / 1000000).toFixed(6) + ", " + (Math.round(this.establishment.contactInfo.longitude * 1000000) / 1000000).toFixed(6);
            },
            getUnitIconForDisplay: function () {
                switch (getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes) {
                    case 'property':
                        return 'fas fa-home'
                    case 'unit':
                        return 'fas fa-home'
                    case 'room':
                    default:
                        return 'fas fa-bed'
                }
            },
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            },
            getLastSyncDate: function() {
                let lastSyncDate = dayjs(this.establishment.lastSyncDate).add(dayjs().utcOffset(), 'minutes');
                return lastSyncDate.format("YYYY-MM-DD HH:mm");
            }
        },
        methods: {
            synchronize: function() {
                console.log("Synchronize");
                this.syncing = true;
                this.message = "";

                this.$http.post('/guest-management/v1/establishments/' + this.establishment.reference + '/sync-with-pms'
                ).then(response => {
                    console.log("Synced establishment. New data:");
                    console.log(response);
                    mutations.updateEstablishment(response.data);
                    this.message = "Successfully synced with " + this.establishment.provider.name;
                    this.success = true;
                    this.$root.$emit('synced-establishment-details', this.establishment.reference);
                }).catch(error => {
                    this.success = false;
                    if (error.response) {
                        this.message = "Error: " + error.response.data.message
                    } else {
                        this.message = "Error syncing with " + this.establishment.provider.name;
                    }
                }).finally(() => {
                    this.syncing = false;
                });
            },
            close: function() {
                console.log("close establishment details");
                this.$root.$emit('close-establishment-details');
            },
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/details";
</style>
